import { ProductPreviewNavigation } from '@common/checkout-utils';
import { getRecommendProductDrLogByCatalogProductId } from '@common/checkout-utils';
import { useTracker, useUBL, useUBLContext, ZigzagEvent } from '@common/log-manager';

const getUrl = () => {
  return typeof window !== 'undefined' ? window.location.href : null;
};

export const useBottomFloatingLog = () => {
  const ublContext = useUBLContext();
  const tracker = useTracker();
  const sendUBL = useUBL();

  const clickPurchaseButtonUBL = (product_url: string, catalog_product_id: string, funnel_type?: string) => {
    ZigzagEvent.subl({
      category: 'click',
      navigation: ublContext.navigation ? ublContext.navigation : 'product_detail',
      object_section: 'bottom_bar',
      object_type: 'button',
      object_id: 'checkout',
      object_url: product_url,
      data: JSON.stringify({
        catalog_product_id,
        funnel_info_type: funnel_type,
      }),
    });
  };

  const clickPurchaseKakaoButtonUBL = (product_url: string, catalog_product_id: string, funnel_type?: string) =>
    sendUBL({
      category: 'click',
      navigation: ublContext.navigation ? ublContext.navigation : 'product_detail',
      object_section: 'bottom_bar',
      object_type: 'button',
      object_id: 'checkout',
      object_url: product_url,
      data: {
        catalog_product_id,
        funnel_info_type: funnel_type,
        text: '카카오로 간편구매',
      },
    });

  const clickScrollUBL = (direction: 'top' | 'bottom') => {
    ZigzagEvent.subl({
      category: 'click',
      navigation: ublContext.navigation ? ublContext.navigation : 'product_detail',
      object_type: 'button',
      object_id: `to_${direction}`,
    });
  };

  const checkoutClickUBL = (catalog_product_id: string) => {
    tracker.addLog({
      category: 'click',
      navigation: ublContext.navigation ? ublContext.navigation : 'product_detail',
      navigation_sub: {
        page_url: getUrl(),
      },
      object_section: 'bottom_bar',
      object_type: 'button',
      object_id: 'checkout',
      data: { catalog_product_id },
    });
  };

  const pageviewUBL = async (catalog_product_id: string) => {
    await tracker.sendImmediately({
      category: 'pageview',
      navigation: ublContext.navigation ? ublContext.navigation : 'zpay_option',
      navigation_sub: { page_url: getUrl() },
      data: { catalog_product_id, is_opened: true },
    });
  };

  const impressionZigzinBannerUBL = (catalog_product_id: string, url: string, banner_text: string) => {
    ZigzagEvent.subl({
      category: 'impression',
      navigation: ublContext.navigation ? ublContext.navigation : 'product_detail',
      object_section: 'bottom_section',
      object_type: 'banner',
      object_id: 'zigzin_cplp',
      object_url: url,
      data: JSON.stringify({
        banner_text,
        catalog_product_id,
      }),
    });
  };

  const clickZigzinBannerUBL = (catalog_product_id: string, url: string, banner_text: string) => {
    ZigzagEvent.subl({
      category: 'click',
      navigation: ublContext.navigation ? ublContext.navigation : 'product_detail',
      object_section: 'bottom_section',
      object_type: 'banner',
      object_id: 'zigzin_cplp',
      object_url: url,
      data: JSON.stringify({
        banner_text,
        catalog_product_id,
      }),
    });
  };

  const clickPurchaseForProductPreviewUBL = (
    product_id: string,
    funnel_type?: string,
    catalog_product_id?: string,
    shop_name?: string,
  ) => {
    const dr_log = getRecommendProductDrLogByCatalogProductId(product_id);

    ZigzagEvent.subl({
      category: 'click',
      navigation: ublContext.navigation ? ublContext.navigation : ProductPreviewNavigation.CART,
      navigation_sub: JSON.stringify({ product_id }),
      object_section: 'bottom_bar',
      object_type: 'button',
      object_id: 'checkout',
      data: JSON.stringify({
        funnel_info_type: funnel_type,
        ...(catalog_product_id && { catalog_product_id }),
        ...(shop_name && { shop_name }),
        ...(dr_log && { server_log: { dr_log } }),
      }),
    });

    sendUBL({
      category: 'click',
      navigation: ublContext.navigation ? ublContext.navigation : ProductPreviewNavigation.CART,
      object_section: 'bottom_bar',
      object_type: 'button',
      object_id: 'checkout',
      data: {
        funnel_info_type: funnel_type,
        ...(dr_log && { server_log: { dr_log } }),
      },
    });
  };

  return {
    clickScrollUBL,
    checkoutClickUBL,
    pageviewUBL,
    clickPurchaseButtonUBL,
    impressionZigzinBannerUBL,
    clickZigzinBannerUBL,
    clickPurchaseForProductPreviewUBL,
    clickPurchaseKakaoButtonUBL,
  };
};
